import React, { useState, useEffect } from 'react';
import { firestore } from '../config/firebaseConfig';
import { collection, getDocs, query, where, orderBy, addDoc, doc, updateDoc } from 'firebase/firestore';
import axios from 'axios';
import './EnviarPilula.css';

const apiUrl = process.env.REACT_APP_API_URL;
const tenantId = localStorage.getItem('tenantId'); // Recupera o e-mail do usuário logado
let sanitizedClientId = '';
if (tenantId) {
  sanitizedClientId = tenantId;
}
const PILULAS_API_URL = `${apiUrl}/send-message?sanitizedClientId=${sanitizedClientId}`;

const EnviarPilula = ({ specificPilulaId = null, onCancel }) => {
  const [pilulas, setPilulas] = useState([]);
  const [students, setStudents] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [sendingDetails, setSendingDetails] = useState({ students: [] });
  const [isSending, setIsSending] = useState(false);
  const [isConfirmButtonVisible, setIsConfirmButtonVisible] = useState(true); // Novo estado para visibilidade do botão Confirmar

  const tenantId = localStorage.getItem('tenantId') || 'unknownTenant';

  const markPilulaAsSent = async (pilulaId) => {
    try {
      const pilulaRef = doc(firestore, 'pilulas', pilulaId);
      await updateDoc(pilulaRef, { enviado: true, prioridade: 0 });
    } catch (error) {
      console.error('Erro ao atualizar pílula:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const pilulasRef = collection(firestore, 'pilulas');
        
        // Filtra registros do tenant atual, ignora o bloqueado e exclui o "CONVITE"
        const pilulasQuery = query(
          pilulasRef,
          where('bloqueado', '==', false),
          where('tenantId', '==', tenantId),
          orderBy('prioridade', 'asc'),
          orderBy('createdAt', 'asc')
        );
  
        const pilulasSnapshot = await getDocs(pilulasQuery);
        
        // Filtra o primeiro registro com título "CONVITE"
        const pilulasData = pilulasSnapshot.docs
          .filter((doc) => doc.data().titulo !== "Convite")
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
  
        setPilulas(pilulasData);
  
        // Carrega contatos filtrados por tenantId
        const contatosRef = collection(firestore, 'contatos');
        const contatosQuery = query(
          contatosRef,
          where('status', '==', 'Ativo'),
          where('tenantId', '==', tenantId)
        );
        const contatosSnapshot = await getDocs(contatosQuery);
        const contatosData = contatosSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setStudents(contatosData);
  
        setError('');
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
        setError('Houve um problema ao buscar dados.');
      }
    };
  
    fetchData();
  }, [tenantId]);
  

  const formatPilulaMessage = (pilula) => {
    if (!pilula) return '';
    return `*${pilula.titulo.trim()}*\n\n${pilula.conteudo.trim()}`;
  };

  const logSendDetails = async (student, pilulaId, titulo) => {
    try {
      await addDoc(collection(firestore, 'logEnvioPilula'), {
        idcontato: student.id,
        telefone: String(student.telefone),
        idpilula: pilulaId,
        titulo: titulo,
        status: 'P',
        datahora: new Date(),
        tenantId: tenantId
      });
    } catch (error) {
      console.error('Erro ao registrar log de envio:', error);
    }
  };

  const getPilulasNaoEnviadasParaContato = async (student) => {
    try {
      const logEnvioPilulaRef = collection(firestore, 'logEnvioPilula');
      const envioQuery = query(
        logEnvioPilulaRef,
        where('idcontato', '==', student.id),
        where('tenantId', '==', tenantId)
      );
      const envioSnapshot = await getDocs(envioQuery);
      const pilulasEnviadasIds = new Set(
        envioSnapshot.docs.map((doc) => doc.data().idpilula)
      );

      let pilulasNaoEnviadas = pilulas.filter(
        (pilula) => !pilulasEnviadasIds.has(pilula.id)
      );

      pilulasNaoEnviadas = pilulasNaoEnviadas.sort((a, b) => a.createdAt.seconds - b.createdAt.seconds);

      return pilulasNaoEnviadas;
    } catch (error) {
      console.error('Erro ao obter pílulas não enviadas para o contato:', error);
      return [];
    }
  };

  const sendMessagesToStudents = async (specificPilulaId = null) => {
    if (isSending) return;
    setIsSending(true);
    setError('');
    setSuccess('');
    setIsConfirmButtonVisible(false); // Oculta o botão Confirmar

    let foundPilulaToSend = false;
    const updatedSendingDetails = [];

    for (let student of students) {
      let pilulasNaoEnviadas = await getPilulasNaoEnviadasParaContato(student);

      if (specificPilulaId) {
        pilulasNaoEnviadas = pilulasNaoEnviadas.filter(
          (p) => p.id === specificPilulaId
        );
      }

      if (pilulasNaoEnviadas.length > 0) {
        foundPilulaToSend = true;
        const pilula = pilulasNaoEnviadas[0];

        updatedSendingDetails.push({
          telefone: student.telefone,
          idPilula: pilula.id,
          data: new Date().toLocaleDateString(),
        });

        try {
          await axios.post(PILULAS_API_URL, {
            sanitizedClientId,
            phoneNumber: student.telefone,
            message: formatPilulaMessage(pilula),
          });

          await logSendDetails(
            student,
            pilula.id,
            pilula.titulo
          );

          await markPilulaAsSent(pilula.id);  
          setSuccess('Mensagens enviadas com sucesso.');
        } catch (error) {
          console.error('Erro ao enviar mensagem:', error);
          // o backend explica o motivo (ex.: contato mandou SAIR, bot desligado)
          setError(error.response?.data?.error || 'Houve um problema ao enviar a mensagem.');
        }
      }
    }

    if (!foundPilulaToSend) {
      setError('Sem pílulas disponíveis no momento.');
    }

    setSendingDetails({ students: updatedSendingDetails });
    setIsSending(false);
  };

  return (
    <div className="modal-content">
      <p></p>

      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      {isConfirmButtonVisible && (
        <button
          onClick={() => sendMessagesToStudents(specificPilulaId)}
          disabled={isSending}
        >
          {isSending ? 'Enviando...' : 'Confirmar'}
        </button>
      )}

      <button
        onClick={onCancel}
        className="cancel-button"
        style={{
          marginTop: '10px',
          backgroundColor: '#ccc',
          color: '#333',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        Fechar
      </button>
    </div>
  );
};

export default EnviarPilula;
